import { Shuffle, User, Users, Sparkles, Bug } from 'lucide-react';

/**
 * Loadout category metadata
 * Centralized definition for icons, labels, and descriptions
 */
export const LOADOUT_CATEGORY_META = {
  random: {
    label: 'Random',
    icon: Shuffle,
    description: 'Cualquier combinación de unidades',
    order: 1,
    hasRegenerate: true,
  },
  solo: {
    label: 'Solo',
    icon: User,
    description: 'Un solo tipo de unidad',
    order: 2,
    hasRegenerate: false,
  },
  official: {
    label: 'Combos',
    icon: Users,
    description: 'Combinaciones oficiales',
    order: 3,
    hasRegenerate: false,
  },
  custom: {
    label: 'Custom',
    icon: Sparkles,
    description: 'Plantilla personalizada guardada',
    order: 4,
    hasRegenerate: false,
  },
  custom_unsaved: {
    label: 'Custom',
    icon: Sparkles,
    description: 'Tu roster modificado (sin guardar)',
    order: 5,
    hasRegenerate: false,
  },
  debug: {
    label: 'Debug',
    icon: Bug,
    description: 'Unidades de prueba',
    order: 6,
    hasRegenerate: false,
  },
};

/**
 * Get category icon component
 * @param {string} category - Category key (random, solo, official, custom, debug)
 * @returns {React.Component} Lucide icon component
 */
export function getCategoryIcon(category) {
  return LOADOUT_CATEGORY_META[category]?.icon || Sparkles;
}

/**
 * Get category label
 * @param {string} category - Category key
 * @returns {string} Human-readable label
 */
export function getCategoryLabel(category) {
  return LOADOUT_CATEGORY_META[category]?.label || category?.charAt(0).toUpperCase() + category?.slice(1);
}

/**
 * Get category metadata
 * @param {string} category - Category key
 * @returns {object} Full metadata object
 */
export function getCategoryMeta(category) {
  return LOADOUT_CATEGORY_META[category] || LOADOUT_CATEGORY_META.custom;
}
